var confettiCanvas = document.getElementById('confetti-canvas');
var isHomeIndex = document.body.classList.contains('template-index');
var cartChangeTimer = null;

if ((typeof Shopify) === 'undefined') {
    window.Shopify = {};
}

// Get from cart.js returns the cart in JSON
if ((typeof Shopify.getCart) === 'undefined') {
    Shopify.getCart = function(callback, cart) {
        if (!cart) {
            return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr) {
                if ((typeof callback) === 'function') {
                    callback(cart, textStatus, xhr);
                  console.log('done1')
                } else {
                  console.log('done2')
                    Shopify.onCartUpdate(cart);
                }
            });
        } else {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else if (typeof Shopify.onCartUpdate === 'function') {
                Shopify.onCartUpdate(cart);
            }
        }
    }
    ;
}


if ( typeof Shopify.formatMoney == 'undefined' ) {
  /**
 * Format currency value according to the store's currency format settings
 * @param {Number} amount - The numeric value to format
 * @param {String} currencyCode - The currency code (e.g., 'USD', 'EUR')
 * @returns {String} The formatted currency value
 */
  Shopify.formatMoney = function formatMoney(amount, currencyCode) {
    var currencyFormat = theme.moneyFormat;
    var formattedAmount = '';
    var amountString = amount.toString();
  
    // Replace placeholders in currency format with actual values
    console.log('Amount: ', amount);
    // Replace placeholders in currency format with actual values
    formattedAmount = currencyFormat.replace('{{amount}}', amountString)
                                 .replace('{{amount_no_decimals}}', amountString)
                                 .replace('{{amount_with_comma_separator}}', amountString.replace(/\./g, ','))
                                 .replace('{{amount_no_decimals_with_comma_separator}}', amountString.replace(/\./g, ','));

  
    // Replace currency placeholder with currency symbol or code
    formattedAmount = formattedAmount.replace('{{currency}}', currencyCode);
  
    return formattedAmount;
  };
}


function add_to_cart_3(product_id, var_id){
  console.log("in add_to_cart_3 function")
  setTimeout(function(){ 
    $.getJSON('/cart.js').then(cart=>{
        global_cart = cart;
//         console.log(cart.items);
        let addedProduct = cart.items.filter(d=>d.id == var_id);
        addedProduct = addedProduct[0];
//         console.log(addedProduct);
        let handle = addedProduct.handle;
        let product_id = addedProduct.product_id;
        product_id = product_id.toString();
        let name = addedProduct.product_title;
        let qty = addedProduct.quantity;
        let currency = "INR";
        let product_image = addedProduct.image;
        let url = `/products/${handle}.json`;
        let cmp = ``;
        let price = ``;
        let sku = ``;
        let images = [];
        let discount = 0;
        // get product details
        $.getJSON(url).then(data=>{
          let product_details = data.product;
          console.log('product_details:',product_details);
          let product_variant = product_details.variants.filter(d=>d.id == var_id);
          product_variant = product_variant[0];
          cmp = product_variant.compare_at_price;
          price = product_variant.price;
          sku = product_variant.sku;
          images = product_variant.images
          
          qty = parseFloat(qty);
          price = parseFloat(price);
          if(cmp != ""){
            cmp = parseFloat(cmp);
            discount = cmp - price;
          }else{
            discount = 0;
            cmp = 0;
          }
          
          console.log('discount: ',discount);
          let single_product = {
            id: product_id,
            name: name,
            image: product_image,
            currency: currency,
            retail_price: cmp,
            price: price,
            discount: discount
          };
          
   
          //call cartUpdate
          // cartUpdated(cart);
          console.log('product added to cart..');
        })
      });
  }, 1000); 
  } 
  
function ajaxCart(form, button) {
    var isButtonFreeGift = $(button).parents('.tsw-free-cart-items').length;
    var isButtonRecommendedUnit = $(button).hasClass( 'RecommendedUnit-AddToCart' );
    
    // Pre-check eligibility for free gifts before allowing add to cart
    if (isButtonFreeGift) {
        // Check if the offer section exists and is enabled
        if (!$('#offerdiff').length || $('.tsw-free-cart-items-disabled').length) {
            alert('Free gift offer is not available at this time.');
            // Re-enable all buttons
            $('.tsw-free-cart-items .CollectionForm__AddToCart, .tsw-free-cart-items .ProductForm__AddToCart').attr('disabled', false);
            button.text(button.attr("data-text"));
            return false;
        }
        
        let offerPrice = parseInt( $('#offerdiff').data('offer-price') );
        let cartPrice = parseInt( $('#offerdiff').data('tag-offer-price') );
        
        // Check if cart meets threshold
        if (offerPrice && cartPrice < offerPrice) {
            alert('You are not eligible for a free gift. Please add more items to your cart.');
            // Re-enable all buttons
            $('.tsw-free-cart-items .CollectionForm__AddToCart, .tsw-free-cart-items .ProductForm__AddToCart').attr('disabled', false);
            button.text(button.attr("data-text"));
            return false;
        }
    }
    
    var data = form.serialize();
    var btnAddedText = isButtonFreeGift ? 'ADDED' : 'Added to cart!';
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(line_item) {

            Shopify.getCart(function(cart) {
                //custom_theme.sidecart();
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{
                    bubbles: true
                }));

                // Cart data
                console.log('Triggering cart update');
                document.dispatchEvent(
                    new CustomEvent('theme:cart:change', {
                        detail: {
                            cart: cart.data,
                        },
                        bubbles: true,
                    })
                );

                if (window.themeGa4 && typeof window.themeGa4.trackAddToCart === 'function') {
                    window.themeGa4.trackAddToCart(line_item, {
                        event_name: button.data('ga4Event') || 'add_to_cart_collection'
                    });
                }

                
                setTimeout(function() {

                    if ( !isButtonFreeGift && !isButtonRecommendedUnit ) {
                        jQuery('.header__desktop__button ').find('a.navlink--cart')[0].click();
                        $(button).removeClass('added-to-cart').attr('disabled', false);
                        button.text( 'Add to cart' );
                    } else {
                        console.log('is offer add to cart - init sidebar update differently');
                        document.dispatchEvent(
                            new CustomEvent('theme:cart:reload', {
                                bubbles: true,
                            })
                        );

                        if ( $('.drawer__body').length ) {
                            var drawerScroller = $('.drawer__body')[0];
                            drawerScroller.scrollTo( {top: 0, behavior: 'smooth' } );
                        }
                    }

                    
                }, 1500);


                if ( isButtonFreeGift ) {
                    // Disable all free gift buttons - already disabled in ajacCartForm, but ensure it stays disabled
                    $('.tsw-free-cart-items .CollectionForm__AddToCart, .tsw-free-cart-items .ProductForm__AddToCart').attr('disabled', true);
                }
              

                button.text( btnAddedText );
                console.log( button );

                $(button).addClass('added-to-cart').attr('disabled', true);
                
            });
        },
        error: function(XMLHttpRequest, textStatus) {
            var error = JSON.parse((XMLHttpRequest.responseText)).description;
            var error_popup = $("<div id='quick-error'></div>");
            error_popup.html("");
            error_popup.append("<h6>" + error + "</h6>");
            alert(error);
            button.text(button.attr("data-text"));
            console.log( XMLHttpRequest.responseText );

            if ( XMLHttpRequest.status ) {
                console.log('request failed, removing all disabled buttons');
                // Re-enable all free gift buttons if there was an error
                if ( isButtonFreeGift ) {
                    $('.tsw-free-cart-items .CollectionForm__AddToCart, .tsw-free-cart-items .ProductForm__AddToCart').attr('disabled', false);
                    $(button).removeClass('added-to-cart');
                }
            }
        }
    };
    jQuery.ajax(params);


}




function ajacCartForm() {
    //ajax cart — intercept button click instead of form submit so the submit
    // event is never dispatched, preventing GA4 Enhanced Measurement from
    // firing a duplicate form_submit event.
    $(document).on("click", ".collection-form .CollectionForm__AddToCart", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var button = $(this);
        var $form = button.closest(".collection-form");
        var isButtonFreeGift = button.parents('.tsw-free-cart-items').length;

        // If this is a free gift button, disable ALL free gift buttons immediately
        if (isButtonFreeGift) {
            $('.tsw-free-cart-items .CollectionForm__AddToCart, .tsw-free-cart-items .ProductForm__AddToCart').attr('disabled', true);
        }

        button.text(button.attr("data-process"));
        ajaxCart($form, button);
    });
}

$(document).ready(function () {
    ajacCartForm();
});



  // Query params
  document.addEventListener('DOMContentLoaded', function(){
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    jQuery('.tsw-test').css('display', 'block');

    console.log( params );

    if ( typeof params['test'] != 'undefined' ) {
        if ( params['test'] == '1' ) {
            console.log('is test mode');
            jQuery('.tsw-test').css('display', 'block');
        }
    }

    
  });


  /*
  * Start Free offer items in cart
  */

  var lastSaved = 0;


  var tsw = {
    fetchCartItems: function(){
        var timestamp = Date.now();
        fetch('/cart?section_id=api-free-offer-cart&timestamp='+timestamp).then(function(response) {
            return response.text()
        }).then(function(response) {
            
            console.log('Free cart items response: ', response.slice(0, 45) );

            // append the html 
            $('.free-gift-slider-cart').html( response );
            $('#cartfreeoffer').html( response );


            if (typeof window.loadSwiper === 'function') {
              window.loadSwiper().then(function () {
                new Swiper('.cartFreeItemsSwiper', {
                slidesPerView: 'auto',
                spaceBetween: 5,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                      slidesPerView: 'auto',
                      spaceBetween: 10,
                      centeredSlides: false,
                    },
                    640: {
                      slidesPerView: 'auto',
                      spaceBetween: 5,
                      centeredSlides: false,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                      centeredSlides: false,
                    },
                },
              });
              });
            }

            if ( $('.free-item-preview').length && !$('.tsw-free-cart-items-disabled').length  ) {
                $('.cart-free-items-heading').removeClass('hidden');
            } else {
                $('.cart-free-items-heading').addClass('hidden');
            }


            // Validate Free gifts in cart
            tsw.validateFreeGift();


            // Progress meter
            if ( $('#offerdiff').length && $('.free-items-progress-text').length ) {
                console.log('Show progress meter only if #offerdiff exists');

                let offerPrice = parseInt( $('#offerdiff').data('offer-price') );
                let cartPrice = parseInt( $('#offerdiff').data('tag-offer-price') );

                let percentage = parseInt( cartPrice / offerPrice * 100  );
                let diff = offerPrice - cartPrice;

                var offerPriceText = $('.free-items-progress-text').data('text');
                var priceDiff = Shopify.money_format.replace('{{amount_no_decimals}}', diff);
                $('.free-items-progress-text').html( offerPriceText.replace( "#{value}", priceDiff ) );

                var prelimit_text = $('.free-gift-heading-nothreshold span').text();
                $('.free-gift-heading-nothreshold span').html( prelimit_text.replace( "||amount||", offerPrice ) );

                // progress color
                let decimalPercentage = percentage / 100;
                    decimalPercentage = decimalPercentage < 0.2 ? 0.2 : decimalPercentage;



                // purple rgba(135, 40, 245, 1)
                    
                let progressColor = `rgba(135, 40, 245,${decimalPercentage})`;
                    progressColor = `#DDC5F2`; /* purple */
                $('.cart-free-items-progress .progress-meter').css({'--progress-line-color' : progressColor});
                $('.cart-free-items-progress .progress-meter .progress-line').css({ 'width': percentage + '%' });

                if ( percentage >= 100 ) {
                    $('.cart-free-items-progress').removeClass('progress-show');
                } else {
                    $('.cart-free-items-progress').addClass('progress-show');
                }

            }



            
        }).catch(function(err) {  
                console.log('Failed to fetch page: ', err);  
        });
    },


    validateFreeGift: function(){
        Shopify.getCart(function(cart) {
            
            let offerPrice = parseInt( $('#offerdiff').data('offer-price') );
            let cartPrice = parseInt( $('#offerdiff').data('tag-offer-price') );
            let freeGiftTag = $('#offerdiff').data('free-gift-tag');
            var isEligible = false;
            var doesHaveFreeGift = false;

            if ( offerPrice /* && cartPrice */ ) {

                if ( cartPrice >= offerPrice ) {
                    console.log('You are eligible for a free gift!');
                    isEligible = true;
                } else {
                    console.log('You are NOT eligible for a free gift!');
                    isEligible = false;
                }

                if ( !isEligible ) {
                    console.log('NOT ELIGIBLE - CHECK CART AND REMOVE ITEMS : ', cart );
                    for ( var i in cart.items ) {
                        let item = cart.items[i];

                        if ( item.product_type.trim() ==  freeGiftTag.trim() ) {
                            doesHaveFreeGift = true;

                            // remove
                            console.log('Remove the free gift');
                            tsw.removeProduct( parseInt(i), 0 );
                        }

                        
                    }
                    
                }
            }



            // If is eligible, however they have multiple quantities of Free Gifts in Cart. 
            // change - 2/2/2023 by Depy
            if ( isEligible ) {
                let foundFreeGift = false;
                let numberOfFreeGifts = 0;
                let changeValues = { updates: {} };
                let shouldUpdate = false;


                for ( var i in cart.items ) {

                    let item = cart.items[i];

                    if ( item.product_type.trim() ==  freeGiftTag.trim() ) {
                        /*
                        if ( foundFreeGift ) {
                            console.log('ALREADY FOUND A FREE GIFT, YOU CAN NOT HAVE MORE THAN 1 FREE GIFT IN YOUR CART');
                            tsw.removeProduct( parseInt(i), 0 );
                        } else {
                            // and if this is the first free gift then update its quantity.
                        }
                        */

                        let productKey = item.key;
                        let quantity = 1; 

                        if ( foundFreeGift ) {
                            quantity = 0;
                            shouldUpdate = true;
                        } else {
                            if ( item.quantity > 1 ) {
                                shouldUpdate = true;
                            }
                        }

                        changeValues.updates[ productKey ] = quantity;

                        foundFreeGift = true;
                        numberOfFreeGifts++;
                    }

                    console.log('Number of free gifts in cart: ' + numberOfFreeGifts);
                }

                // whether or not we should update the cart
                if ( shouldUpdate ) {
                    console.log( `Number of Free gifts ${numberOfFreeGifts} | `, changeValues );
                    
                    var params = {
                        type: 'POST',
                        url: `${window.theme.routes.cart}/update.js`,
                        data: changeValues,
                        dataType: 'json',
                        success: function(line_item) {
                            tsw.updateCart();      
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            console.log('Some error occured', XMLHttpRequest);
                        }
                    };

                    jQuery.ajax(params);
                }
            } 






        });
    }, 

    removeProduct: function( index, qty = 0 ){

        const data = {
            line: index + 1,
            quantity: qty,
        };
            

        var params = {
            type: 'POST',
            url: `${window.theme.routes.cart}/change.js`,
            data: data,
            dataType: 'json',
            success: function(line_item) {

                tsw.updateCart();
                    
            },
            error: function(XMLHttpRequest, textStatus) {
                console.log('Some error occured', XMLHttpRequest);
            }
        };
        jQuery.ajax(params);

    },

    updateCart: function(){
        Shopify.getCart(function(cart) {
            //custom_theme.sidecart();
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));

            // Cart data
            console.log('Triggering cart update');
            document.dispatchEvent(
                new CustomEvent('theme:cart:change', {
                    detail: {
                        cart: cart.data,
                    },
                    bubbles: true,
                })
            );
        });
    }, 

    calculateSaved: function(){
        console.log('Calculating saved amount..');
        $cartItems = $('.cart__items .cart__items__row');
        $cartItemTotalDiscount = $('.drawer .cart__items').data('total-discount');
        $totalFinalPrice = 0;
        $totalCompareWith = 0;
        $totalSaved = 0;

        $cartItems.each(function(e){
            $cart_item_price = $( this ).find('.cart__items__price');
            if ( $cart_item_price.length ) {
                let lineQty = $cart_item_price.data( 'line-item-qty' );
                let lineComparePrice = $cart_item_price.data('line-item-compare_at_price');
                let lineFinalPrice = $cart_item_price.data('line-item-final_price');
                let itemDiscountedPrice = $cart_item_price.data('discounted-item-price');
                let lineOriginalLinePrice = $cart_item_price.data('line-item-line_price');

                
                if ( lineQty ) {


                    // Add to total compare with price
                    if ( lineComparePrice ) {
                        $totalCompareWith += lineComparePrice * lineQty;
                    } else if ( lineOriginalLinePrice ) {
                        console.log('Line original line price: ', lineOriginalLinePrice);
                        $totalCompareWith += lineOriginalLinePrice /* * lineQty */; // don't need to multiply it, line item always give multiplied value
                    } else {
                        $totalCompareWith += lineFinalPrice * lineQty;
                    }

                    // Add to final price
                    $totalFinalPrice += lineFinalPrice * lineQty;
                }
            };
        });

        console.log( 'total compare with price : ', $totalCompareWith );
        console.log( 'total final price : ', $totalFinalPrice );
        

        // Calculate the saved amount
        if ( $totalCompareWith > $totalFinalPrice ) {
            $totalSaved = $totalCompareWith - $totalFinalPrice;
        }


        // After the items also calculate the total cart discounts
        console.log( 'total cart discount : ', $cartItemTotalDiscount );
        if ( $cartItemTotalDiscount  ) {
            // $totalSaved += $cartItemTotalDiscount;
        }

        // Insert into the UI
        if ( $totalSaved ) {
            $totalSaved /= 100;
            $totalSaved = Math.floor( $totalSaved );
            console.log('Total Saved:: ', $totalSaved);
            let templateText = $( '.saved-amount-message .saved-message-text' ).data('text');
            if ( templateText ) {
                let templateText = $( '.saved-amount-message .saved-message-text' ).data('text');
                
                let moneyFormat = Shopify.formatMoney( $totalSaved );
                let updatedText = templateText.replace('||amount||', moneyFormat);
                $( '.saved-amount-message .saved-message-text' ).html( updatedText  );
                $( '.saved-amount-message' ).fadeIn();

                $( '.saved-amount-message' ).addClass('glow');
                window.setTimeout(function(){
                    $( '.saved-amount-message' ).removeClass('glow');
                }, 700);


                // CONFETTI FUN!
                if ( $totalSaved > lastSaved ) {
                    $( '#confetti-canvas' ).fadeIn(100);
                    // you should  only initialize a canvas once, so save this function
                    // we'll save it to the canvas itself for the purpose of this demo
                    // Confetti canvas
                    confettiCanvas = document.getElementById('confetti-canvas');
                    
                    if ( confettiCanvas && typeof confetti !== 'undefined' ) {
                        confettiCanvas.confetti = confettiCanvas.confetti || confetti.create(confettiCanvas, { resize: true});
                        confettiCanvas.confetti({
                            spread: 70,
                            origin: { y: 1.2 }
                        });
                    }

                    window.setTimeout(function(){
                        $( '#confetti-canvas' ).fadeOut(700);
                    }, 2500);
                }

                lastSaved = $totalSaved;

                
                
            }
        } else {
            $('.saved-amount-message p').text('');
            $('.saved-amount-message').fadeOut();
        }

        return $totalSaved;
    },


    // Fetch recommended unit,
    fetchRecommendedUnits: function(){
        var timestamp = Date.now();
        fetch('/cart?section_id=api-recommended-unit&timestamp='+timestamp).then(function(response) {
            return response.text()
        }).then(function(response) {

            console.log('Recommended Unit Response: ', response.slice(0, 45) );

            // append the html 
            $('.tsw-cart-recommended-container').html( response );

            // Hide the unit if number of products is 0
            var numberOfProducts = $('.tsw-cart-recommended-container .recommended-slides-wrap .cart-item-slide').length;
            if ( numberOfProducts ) {
                $('.tsw-cart-recommended-container').fadeIn(200);
            } else {
                $('.tsw-cart-recommended-container').fadeOut(200);
            }

            if (typeof window.loadSwiper === 'function') {
              window.loadSwiper().then(function () {
                new Swiper('.cartRecommendedUnitSwiper', {
                  slidesPerView: 'auto',
                  spaceBetween: 5,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 'auto',
                      spaceBetween: 10,
                      centeredSlides: false,
                    },
                    640: {
                      slidesPerView: 'auto',
                      spaceBetween: 5,
                      centeredSlides: false,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                      centeredSlides: false,
                    },
                  },
                });
              });
            }

        }).catch(function(err) {  
                console.log('Failed to fetch page: ', err);  
        });
    },

    // Check country and show popup
    internationalPopup: function () {

        var supportedCountries = ["IN"];
        // Only continue if the popup exists
        if ($('.international-modal-main').length) {

            var apiKey = "AIzaSyCgBhQIOOMk4v08VKuYt34mhKxRajdi5v4";

            // Request data
            $.ajax({
                type: "POST",
                url: `https://ipapi.co/json/`,
                data: {},
                success: function (res) {
                    console.log('got success response!', res);
                    console.log('got success response!', res.country_name);


                    if (res.country) {

                        var countryFound = false;
                        var countryName = '';
                        var countryCode = '';

                        // var fetchCountryObject = _.find(res.results.country);

                        if (res.country) {
                            countryFound = true;
                            countryName = res.country_name;
                            countryCode = res.country_code;


                            // Enter the country name
                            var textHtml = $('.international-modal-main .modal-info-text').html();
                            textHtml = textHtml.replaceAll('|country_name|', countryName);
                            $('.international-modal-main .modal-info-text').html(textHtml);


                            // First check if countryCode is not in supportedCountries, only when not in it continue
                            if (supportedCountries.indexOf(countryCode) < 0) {


                                // that means country is not supported
                                console.log('Country is: ', countryCode, countryName);

                                var shouldShowInternationalPopup = window.localStorage.getItem('show_international_popup');

                                if (shouldShowInternationalPopup != 'no') {
                                    // show the popup
                                    window.setTimeout(function(){
                                        $('.international-modal-main').addClass('active').fadeIn(200);
                                    }, 2500);
                                } else {

                                }
                            } else {
                                console.log("Country is ", countryCode, " dont show the popup");
                            }

                        }


                    }
                },
                dataType: "json"
            }).fail(function () {
                console.log('Geolocation request failed.');
            });

        }
    }
  };

  $( document ).ready(function(){

    if (!isHomeIndex) {
      tsw.fetchCartItems();
      tsw.calculateSaved();
    }

    $("#test-cart-products .rte").removeClass("rte");
    $("#test-cart-products .font--3").removeClass("font--3 standard__rte");


    $('body').on('click', '.close-item-preview', function(e){
        e.preventDefault();
        e.stopPropagation();
        
        $('.free-item-preview').removeClass('show-preview');
        
    });

    $('body').on('click', '.product-img-zoom, .product-img-zoom-link', function(e){
        e.preventDefault();
        e.stopPropagation();

        var prd_img = $( this ).data('product-img');
        $('.free-item-preview').addClass('show-preview');
        $('.free-item-preview .free-item-preview-img img').attr('src', prd_img);
    });


    // Smooth scroll with offer heading in sidebar cart
    $('body').on('click', '[data-offer-target]', function(e){
      e.preventDefault();
      $('[data-drawer-scrolls]').animate({
        scrollTop: $("#shopify-section-api-free-offer-cart").offset().top - 20
      }, 700);
    });


    // International popup interactions

    // Only open on interaction
    var isFirstInteraction = true;

    function handleFirstInteraction() {
        // Code to run on the first interaction
        console.log("First interaction!");
        tsw.internationalPopup();

        // Set the flag to false to prevent further execution
        isFirstInteraction = false;

        // Remove event listeners to prevent unnecessary function calls
        document.removeEventListener("click", handleFirstInteraction);
        document.removeEventListener("scroll", handleFirstInteraction);
        document.removeEventListener("touchstart", handleFirstInteraction);
    }

    document.addEventListener("click", handleFirstInteraction, { passive: true });
    document.addEventListener("scroll", handleFirstInteraction, { passive: true });
    document.addEventListener("touchstart", handleFirstInteraction, { passive: true });
    
    

    $('body').on('click', '.international-modal-close', function(e){
        e.preventDefault();
        $('.international-modal-main').removeClass('active');
        window.localStorage.setItem('show_international_popup', 'no');
    });

    $('body').on('click', '.continue-india-store', function(e){
        e.preventDefault();
        $('.international-modal-main').removeClass('active');
        window.localStorage.setItem('show_international_popup', 'no');
    });

    
  });

  // On cart update, refetch the free gifts wrapper (debounced)
  document.addEventListener('theme:cart:change',function(){
    if (!tsw) return;
    if (cartChangeTimer) window.clearTimeout(cartChangeTimer);
    cartChangeTimer = window.setTimeout(function () {
      tsw.fetchCartItems();
      tsw.fetchRecommendedUnits();
      window.setTimeout(function () {
        tsw.calculateSaved();
      }, 800);
    }, 120);
  });


  $( document ).ready(function(){
    var cartDrawer = document.getElementById('drawer-cart');
    if ( cartDrawer ) {
       cartDrawer.addEventListener('theme:drawer:open',function(){
          if ( tsw ) {
              tsw.fetchCartItems();
              tsw.fetchRecommendedUnits();
              
              window.setTimeout(function(){
                  tsw.calculateSaved();
              }, 1200);
      
              console.log('Using theme:drawer:open to refetch TSW offer cart items');
          }
        });
    }
  });

  document.addEventListener('theme:cart:init', function (e) {
    if (!tsw) return;
    if (isHomeIndex && !(e.detail && e.detail.deferred)) return;
    tsw.fetchCartItems();
    tsw.fetchRecommendedUnits();
    window.setTimeout(function () { tsw.calculateSaved(); }, 800);
  });
  document.addEventListener('theme:cart:reload',function(){
      if ( tsw ) {
          tsw.fetchCartItems();
          tsw.fetchRecommendedUnits();
          window.setTimeout(function(){
            tsw.calculateSaved();
          }, 800);
          console.log('RELOAD: Using theme:cart:reload to refetch TSW offer cart items');
      }
  });


/*
* All pagespeed optimization related code here
*/

function convertToLazyVideo() {
      var lazyVideos = document.querySelectorAll('.custom-video-lazyload');
  
      lazyVideos.forEach(function(video) {
        var videoSrc = video.getAttribute('data-src');
        video.setAttribute('src', videoSrc);
        video.removeAttribute('data-src');
        video.classList.remove('custom-video-lazyload');
        video.classList.add('custom-video-lazyloaded');
      });
}
function replaceDataSrcWithSrc() {
    console.log(';;; RUNNING FIRST INTERACTION - REPLACE_DATASRC_WITH_SRC ;;;');
    var iframes = document.querySelectorAll('.custom-lazyload');
    if (iframes) {
      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        var dataSrc = iframe.getAttribute('data-src');
        if (dataSrc) {
          iframe.setAttribute('src', dataSrc);
          iframe.removeAttribute('data-src');
          iframe.classList.add('custom-lazyloaded');
          iframe.classList.remove('custom-lazyload');
        }
      }
    }


    // Lazy load videos
    convertToLazyVideo();

    //
    // Remove event listeners after they have been triggered
      document.removeEventListener('click', replaceDataSrcWithSrc);
      document.removeEventListener('touchstart', replaceDataSrcWithSrc);
      document.removeEventListener('scroll', replaceDataSrcWithSrc);
}

function initHomeVideos() {
  convertToLazyVideo();
}

if (isHomeIndex) {
  if (typeof window.tswSchedule === 'function') {
    window.tswSchedule(initHomeVideos, 'below', 200);
  } else {
    window.setTimeout(initHomeVideos, 2800);
  }
  document.addEventListener('click', replaceDataSrcWithSrc, { once: true, passive: true });
  document.addEventListener('touchstart', replaceDataSrcWithSrc, { once: true, passive: true });
} else {
  document.addEventListener('click', replaceDataSrcWithSrc);
  document.addEventListener('touchstart', replaceDataSrcWithSrc);
  document.addEventListener('scroll', replaceDataSrcWithSrc);
}
